// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2bMMt","bigColWidth":"Table_bigColWidth__3ibjt","biggerColWidth":"Table_biggerColWidth__2nhY6","row":"Table_row__22kpG","col":"Table_col__3XfA3"};